import { IStartSigningProfile } from '@app/core/model/env-config.model';
import { ITransactionData } from './model/transaction-data.model';
import { SignatureType } from 'ngx-mat-esign360';

export const MIN_POSSIBLE_SIGN_FIELD_WIDTH_PX = 5;
export const MIN_POSSIBLE_SIGN_FIELD_HEIGHT_PX = 5;

export const DEFAULT_START_SIGNING_PROFILE: IStartSigningProfile = {
  canAddClient: true,
  canRemoveClient: true,
  canUploadFiles: true,
  canRemoveFiles: true,
  canSelectDefaultSigType: true,
  canSelectGlobalSigType: true,
  canEditDocSigners: true,
  canSetClientIdAutoIncrement: true,
  canChangeSignFieldPriority: true,
  canEditTransactionJson: true,
  rememberLastData: true,
  defaultRequestSignatureSubject: 'Výzva k podpisu / Signature request',
  defaultRequestSignatureBody:
    'Dobrý den, toto je váš odkaz k podepsání transakce: %link%.\nGreetings, this is your link for signing the transaction: %link%.',
  clientFieldsVisibility: {},
  defaultSendMailIfCompleted: true,
  minSignFieldSize: {
    width: MIN_POSSIBLE_SIGN_FIELD_WIDTH_PX,
    height: MIN_POSSIBLE_SIGN_FIELD_HEIGHT_PX,
  },
};

export const DEFAULT_START_SIGNING_TEMPLATE: ITransactionData = {
  autoIncrementClientId: false,
  defaultSignatureType: SignatureType.Hand,
  documentsData: [],
  signFieldsByDocument: {},
  formData: undefined,
};
